import React, { useEffect, useState } from 'react';
import { Flex, Text } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import BemClass from '@upsales/components/Utils/bemClass';
import './LoadingIndicator.scss';

export const LoadingIndicator = () => {
	const classes = new BemClass('LoadingIndicator');
	const { t } = useTranslation();
	const [textIndex, setTextIndex] = useState(0);

	const loadingTexts = [
		'aiChat.loading.analyzingData',
		'aiChat.loading.thinking',
		'aiChat.loading.loading',
		'aiChat.loading.contemplating',
		'aiChat.loading.reasoning',
		'aiChat.loading.processing'
	];

	useEffect(() => {
		const interval = setInterval(() => {
			setTextIndex(prev => (prev + 1) % loadingTexts.length);
		}, 2000);

		return () => clearInterval(interval);
	}, []);

	const getDisplayText = () => {
		return t(loadingTexts[textIndex]) + '…';
	};

	return (
		<Flex alignItems="center" gap="u7">
			<div className={classes.elem('loader').b()} />
			<Text color="purple">{getDisplayText()}</Text>
		</Flex>
	);
};
